"use client";

import React, { useState } from "react";
import Main_heading_holder from "../../common_components/main_heading_holder/Main_heading_holder";
import "./FAQ.css";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Is an Online MBA worth it?",
      answer:
        "Yes, especially when pursued from an accredited, UGC-approved university with strong industry recognition and placement support.",
    },
    {
      question: "Is an Online MBA valid in India?",
      answer:
        "Yes — UGC-approved online MBA programs carry the same recognition as their on-campus counterparts.",
    },
    {
      question: "Can working professionals pursue this?",
      answer:
        "Absolutely — these programs are specifically designed around the schedules of working professionals.",
    },
    {
      question: "What is the average fee?",
      answer:
        "Fees range from roughly ₹98,000 to ₹2,00,000 depending on the university and specialization chosen.",
    },
    {
      question: "Which specialization should I pick?",
      answer:
        "It depends on your career goals — Finance, Marketing, Business Analytics and HR are currently the most in-demand tracks.",
    },
  ];

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="FAQ">
      <div className="container">
        <Main_heading_holder
          heading="Frequently "
          spanHeading="asked questions"
          headingType="h3"
        />

        <div className="faq-wrapper reveal">
          {faqs.map((faq, index) => {
            const isActive = activeIndex === index;

            return (
              <div
                className={`faq-item ${isActive ? "active" : ""}`}
                key={index}
              >
                <button
                  type="button"
                  className="faq-q"
                  onClick={() => toggleFaq(index)}
                  aria-expanded={isActive}
                >
                  <h4>{faq.question}</h4>

                  <span className="faq-toggle">{isActive ? "−" : "+"}</span>
                </button>

                <div className={`faq-a ${isActive ? "show" : ""}`}>
                  <div className="faq-answer-content">{faq.answer}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
